<template>
    <div class="cards-box">
        <div class="list-container">
            <header><p>Cards</p><input placeholder="Search" class="list-container-search" @keyup="searchCards"/><p class="btn" @click="$emit('newCard')">new card</p><div class="x" @click="$emit('exit')"></div></header>
            <div class="cards-list">
                <div v-for="card in cards" class="card-item">
                    <p class="card-title ellip">{{ card.title }}</p>
                    <Card :card="card" @editCard="$emit('editCard',card)" @setExpiry="$emit('setExpiry',card)" @removeCard="$emit('removeCard',card)"/>
                    <div class="card-wallets">
                        <div v-for="wallet in card.wallets" class="card-wallet">
                            <p>{{ wallet.title }}</p><div class="x" @click="removeFromWallet(wallet,card)"></div>
                        </div>
                        <p class="btn" @click="addToWallet(card)">add to wallet</p>
                    </div>
                </div>
            </div>
            <div v-if="selectWallet.length > 0" class="fixed-scroller">
                <div class="v-alert select-wallet">
                    <header><p>Add to Wallet</p><div class="x" @click="selectWallet = []"></div></header>
                    <div class="select-list">
                        <div v-for="wallet in selectWallet" class="select-item" @click="addCardToWallet(wallet)">
                            <p>{{ wallet.title }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Card from '../components/Card'
import WebSoc from '../utils/WebSoc.js'
import Alert from '../utils/Alert.js';

export default {
    components: {
        Card
    },
    computed: {
        cards () { return this.$store.getters.cards },
        wallets () { return this.$store.getters.wallets }
    },
    created () {
        //this.cards.forEach(card => card.wallets = []);
    },
    watch: {

    },
    data () {
        return {
            card: false,
            show: false,
            selectWallet: []
        }
    },
    mounted () {

    },
    methods: {
        searchCards ( e ) {
            console.log('e.keyCode',e.keyCode);
        },
        updateCardWallets () {

        },
        addToWallet ( card ) {
            this.card = card;
            this.selectWallet = this.wallets;
        },
        removeFromWallet ( wallet, card ) {
            WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $pull: { cards: { _id: card._id } }}} ,resp => {
                console.log('updated',resp);
                var cards = wallet.cards.length;
                console.log('start',cards);
                var interval = setInterval(() => {
                    console.log(cards,wallet.cards.length);
                    if ( cards != wallet.cards.length ) {
                        clearInterval(interval);
                        this.$forceUpdate()
                    }
                },500);
            })
        },
        addCardToWallet ( wallet ) {
            this.selectWallet = [];
            var card = this.card;
            var current = card.wallets.find(w => w._id == wallet._id);
            if ( current ) return Alert.message('You cannot add the same<br>card twice to a Wallet');
            WebSoc.SEND('update',{ DB: 'wallets', _id: wallet._id, update: { $push: { cards: { _id: card._id } }}},resp => {
                this.card = false;
            })
        }
    }
}

</script>

<style lang="scss">
.select-wallet {
    .select-item {
        padding: 5px 10px;
        margin-left: 0px;
        width: calc(100% - 20px);
        text-decoration: underline;
        color: blue;
        &:nth-child(odd) {
            background-color: rgba(100,100,100,0.3);
        }
    }
}    
.cards-box {
    width: 100%;
    height: calc(100% - 50px);
    float: left;
    position: fixed;
    top: 50px;
    left: 0px;
    .show-cards {
        position: fixed;
        top: 60px;
        right: 0px;
        background-color: green;
        color: white;
        width: 120px;
        font-size: 20px;
        text-align: center;
        line-height: 2;
    }
    .list-container {
        position: absolute;
        background-color: white;
        height: calc(100% - 50px);
        width: 100%;
        top: 0px;
        margin: 0px;
        overflow-y: scroll;
        .list-container-search {
            position: absolute;
            top: 0px;
            left: 120px;
            width: 307px;
            font-size: 21px;
            margin: 4px;
        }
        header {
            p.btn {
                position: absolute;
                right: 90px;
                top: 0px;
                line-height: 30px;
                margin: 4px;
            }
        }
    }
    .cards-list {
        > .card-item {
            width: 424px;
            margin: 10px;
            float: left;
            .ad-img {
                margin: 0px;
            }
        }
        .card-title {
            font-weight: bold;
            margin: 5px 10px;
        }
        .card-wallets {
            float: left;
            width: calc(100% - 20px);
            margin: 10px;
            border: 1px solid #c0c0c0;
            .card-wallet {
                position: relative;
                padding: 5px;
                font-weight: bold;
                border-bottom: 1px solid #c0c0c0;
                float: left;
                width: calc(100% - 10px);
                .x { transform: scale(0.5); }
            }
            .btn {
                margin-top: 20px;
                width: calc(100% - 20px);
            }
        }
    }
}
</style>